/*
Amount breakdown shown in the attest detail summary card.

- orgCost     : what the organisation is charged. This is the amount stored on the
                attest itself (gross + employer's fee, see ReimbursementService).
- employerFee : employer's fee included in orgCost.
- payout      : what the recipient actually receives (gross - income tax).
*/

const sum = (list, selector) =>
    (Array.isArray(list) ? list : []).reduce((total, item) => total + (selector(item) ?? 0), 0);

export function GetAttestAmounts(data) {
    const modelInfo = data?.modelInfo ?? {};
    const orgCost = data?.amount ?? 0;

    if (data?.model === "Förrättning") {
        const employerFee = sum(modelInfo.fixeds, i => i.employmentTax) + (modelInfo.mileage?.employmentTax ?? 0);
        const payout = sum(modelInfo.fixeds, i => i.net)
            + (modelInfo.mileage?.net ?? 0)
            + sum(modelInfo.expenses, i => i.amount);
        return {orgCost, employerFee, payout};
    }

    if (data?.model === "Arvode") {
        return {
            orgCost,
            employerFee: modelInfo.employmentTax ?? 0,
            payout: modelInfo.net ?? 0,
        };
    }

    // Betala / Faktura / Intern transaktion: no payroll taxes involved.
    return {
        orgCost,
        employerFee: 0,
        payout: modelInfo.amount ?? orgCost,
    };
}

/*
Per-unit price shown in the detail rows (Å-pris): total amount divided by hours or km.
Returns null when it cannot be derived.
*/
export function GetUnitPrice(amount, quantity) {
    if (!amount || !quantity) {
        return null;
    }
    return amount / quantity;
}
